var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pt-5",attrs:{"id":"course"}},[(_vm.current !== 'exam')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('Sidebar')],1),_c('div',{staticClass:"col-lg-8"},[_c(_vm.courseComponent,{tag:"Component"})],1)]):_c('Exam')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }